module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-matomo/gatsby-browser.js'),
      options: {"plugins":[],"matomoUrl":"//stats.braunschweig.de","siteId":8},
    },{
      plugin: require('../gatsby-browser.js'),
      options: {"plugins":[]},
    }]
